//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Represents the approval status of a content channel item */
export const ContentChannelItemStatus = {
    /** The ContentChannelItem is pending approval. */
    PendingApproval: 1,

    /** The ContentChannelItem has been approved. */
    Approved: 2,

    /** The ContentChannelItem was denied. */
    Denied: 3
} as const;

/** Represents the approval status of a content channel item */
export const ContentChannelItemStatusDescription: Record<number, string> = {
    1: "Pending Approval",

    2: "Approved",

    3: "Denied"
};

/** Represents the approval status of a content channel item */
export type ContentChannelItemStatus = typeof ContentChannelItemStatus[keyof typeof ContentChannelItemStatus];
